// LandingScreen.jsx
import React from "react";
import ReactGA from "react-ga4";

import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";

import Icons from "../helpers/icons";
import { Link } from "react-router-dom";

const LandingScreen = () => {
    return (
        <Box
            className="text-focus-in"
            sx={{
                minHeight: "100svh",
                position: "relative",
                display: "flex",
                alignItems: "center",
                color: "white",
                backgroundImage: {
                    xs: "linear-gradient(90deg, rgba(0,0,0,.88) 0%, rgba(0,0,0,.55) 70%, rgba(0,0,0,.25) 100%), url('/images/alejandro-loda.jpg')",
                    md: "linear-gradient(90deg, rgba(0,0,0,.82) 0%, rgba(0,0,0,.35) 48%, rgba(0,0,0,0) 72%), url('/images/alejandro-loda.jpg')",
                },
                backgroundSize: "cover",
                backgroundPosition: { xs: "60% center", md: "center" },
            }}
        >
            <Box
                component="img"
                src="/images/logo-cuervo.svg"
                alt="Alejandro Loda"
                sx={{
                    position: "absolute",
                    bottom: { xs: 24, md: 40 },
                    right: { xs: 24, md: 56 },
                    width: { xs: 55, md: 75 },
                    filter: "invert(1)",
                }}
            />

            <Box sx={{ px: { xs: 3, md: 7 }, maxWidth: 650 }}>
                <Typography
                    component="h1"
                    sx={{
                        fontSize: { xs: "3.5rem", sm: "5rem", md: "6.5rem" },
                        fontWeight: 700,
                        lineHeight: 0.9,
                        letterSpacing: "-0.05em",
                    }}
                >
                    Alejandro
                    <br />
                    Loda
                </Typography>

                <Typography
                    sx={{
                        mt: 3,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                        letterSpacing: ".18em",
                        textTransform: "uppercase",
                        opacity: 0.8,
                    }}
                >
                    Magia · Mentalismo
                </Typography>

                <Box
                    sx={{
                        mt: 1.5,
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        width: "fit-content",
                    }}
                >
                    <Box
                        component="img"
                        src="/images/espigas.svg"
                        alt=""
                        sx={{
                            width: { xs: 42, md: 50 },
                            height: "auto",
                            filter: "brightness(0) invert(1)",
                            opacity: 0.8,
                        }}
                    />

                    <Typography
                        sx={{
                            fontSize: { xs: ".85rem", md: ".95rem" },
                            lineHeight: 1.3,
                        }}
                    >
                        Premio Nacional de Magia
                        <br />
                        <Box component="span" sx={{ opacity: 0.7 }}>
                            Invención · 2026
                        </Box>
                    </Typography>
                </Box>

                <Box
                    sx={{
                        mt: 4,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <Button
                        component={Link}
                        to="/magia"
                        variant="outlined"
                        sx={{
                            color: "white",
                            borderColor: "rgba(255,255,255,.6)",
                            textTransform: "none",
                            "&:hover": { borderColor: "white" },
                        }}
                    >
                        Mis libros de magia
                    </Button>

                    <Tooltip title="Instagram">
                        <IconButton
                            aria-label="Instagram"
                            sx={{ color: "white" }}
                            onClick={() => {
                                ReactGA.event("instagram_click");
                                window.open(
                                    "https://www.instagram.com/mago.alejandroloda",
                                    "_blank",
                                );
                            }}
                        >
                            <Icons.Instagram />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="hola@alejandroloda.com">
                        <IconButton
                            aria-label="Email"
                            sx={{ color: "white" }}
                            onClick={() => {
                                ReactGA.event("email_click");
                                window.open("mailto:hola@alejandroloda.com");
                            }}
                        >
                            <Icons.Email />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
        </Box>
    );
};

export default LandingScreen;
